import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { faqData } from '../data/mockData';

const FAQ = () => {
  const [openFaq, setOpenFaq] = useState(null);

  const toggleFaq = (id) => {
    setOpenFaq(openFaq === id ? null : id);
  };

  return (
    <section id="faq" className="section-container section-alt">
      <div className="section-content">
        <div className="section-header">
          <h2 className="section-title">Frequently Asked Questions</h2>
          <p className="section-description">
            Everything you need to know about FindMeAgent
          </p>
        </div>

        <div className="faq-container">
          {faqData.map((faq) => (
            <div key={faq.id} className={`faq-item ${openFaq === faq.id ? 'faq-open' : ''}`}>
              <button 
                className="faq-question"
                onClick={() => toggleFaq(faq.id)}
              >
                <span className="faq-question-text">{faq.question}</span>
                <ChevronDown 
                  className={`faq-icon ${openFaq === faq.id ? 'faq-icon-rotate' : ''}`}
                  size={20}
                />
              </button>
              <div className={`faq-answer ${openFaq === faq.id ? 'faq-answer-open' : ''}`}>
                <p className="faq-answer-text">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
